function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.25
}, React.createElement("circle", {
  fill: "#2F3947",
  opacity: 0.5,
  cx: 18,
  cy: 18,
  r: 18
}), React.createElement("path", {
  d: "M17.198 18.883a1.514 1.514 0 01-1.748.052l-1.677-1.127a1.19 1.19 0 00-1.464.115.953.953 0 00-.065 1.34l2.716 3.082c.048.055.1.107.155.156.771.69 1.99.66 2.722-.066l6.892-6.841a.893.893 0 00-.018-1.3 1.116 1.116 0 00-1.428-.069l-6.085 4.658z",
  fill: "#F7F8FB"
}));

var SvgTickDisabledBig = function SvgTickDisabledBig(props) {
  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='36px' height='36px' viewBox='0 0 36 36' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' opacity='0.25'%3E %3Cg transform='translate(-370.000000, -481.000000)'%3E %3Cg transform='translate(370.000000, 481.000000)'%3E %3Cg%3E %3Cg%3E %3Cg%3E %3Ccircle fill='%232F3947' opacity='0.5' cx='18' cy='18' r='18'%3E%3C/circle%3E %3Cpath d='M17.1978047,18.8830766 C16.693696,19.2689499 15.9782545,19.290076 15.4495049,18.9347018 L13.7734119,17.8081947 C13.3211309,17.5042153 12.7020137,17.552736 12.3092143,17.9229452 C11.9236019,18.2863808 11.8951511,18.8668148 12.2435683,19.2622105 L14.9600009,22.3449107 C15.0084809,22.3999275 15.0603703,22.4521943 15.1153974,22.5014374 C15.8863106,23.191319 17.1046449,23.1615712 17.8366231,22.4349937 L24.7285544,15.5939131 C25.0973061,15.2278822 25.0893867,14.6515652 24.7107007,14.2946578 C24.3239867,13.930184 23.7075454,13.9001539 23.2830219,14.2251081 L17.1978047,18.8830766 Z' fill='%23F7F8FB'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgTickDisabledBig as ReactComponent };